import { useState, useRef } from 'react';
import { Control, Controller, FieldValues, RegisterOptions } from 'react-hook-form';
import { formatISO } from 'date-fns';
import { getEndOfMonth, TAFLocale } from '@shared/utils/dateUtils.ts';
import DatePicker from 'react-datepicker';

interface IMonthInputProps {
    id?: string;
    minDate?: Date;
    maxDate?: Date;
    type?: string;
    className?: string;
    name?: string;
    value?: any;
    onChange?: any;
    required?: boolean;
    register?: any;
}
export const MonthInput = ({ minDate, maxDate, value, register, ...props }: IMonthInputProps) => {
    const [selectedDate, setSelectedDate] = useState(value ? new Date(value) : null);
    const inputRef = useRef<HTMLInputElement>(register);

    function setNativeValue(element: any, value: string) {
        const valueSetter = Object.getOwnPropertyDescriptor(element, 'value')?.set;
        const prototype = Object.getPrototypeOf(element);
        const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;

        if (valueSetter && valueSetter !== prototypeValueSetter) {
            prototypeValueSetter?.call(element, value);
        } else {
            valueSetter?.call(element, value);
        }
    }

    const passEventToInput = (date: any) => {
        const formattedDate = formatISO(date);
        setNativeValue(inputRef.current, formattedDate);
        inputRef.current.dispatchEvent(new Event('change', { bubbles: true }));
    };

    return (
        <>
            <input
                type='text'
                readOnly
                style={{ display: 'none' }}
                id='employmentAmendmentStartDate'
                ref={inputRef}
                className='form-control'
                {...props}
                required
            />
            <DatePicker
                className='form-control'
                locale={TAFLocale}
                minDate={minDate}
                maxDate={maxDate}
                selected={selectedDate}
                onChange={(date) => {
                    setSelectedDate(date);
                    passEventToInput(date);
                }}
                dateFormat='MMMM yyyy'
                showMonthYearPicker
                showPopperArrow={false}
                onChangeRaw={(e) => e.preventDefault()}
            />
        </>
    );
};
interface IMonthInputControllerProps {
    name: string;
    id: string;
    rules: Omit<RegisterOptions<FieldValues, string>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>;
    control: Control<FieldValues>;
    minDate: Date;
    maxDate: Date;
    endOfMonth?: boolean;
}
export const MonthInputController = ({ name, id, control, rules, minDate, maxDate, endOfMonth }: IMonthInputControllerProps) => {
    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={({ field }) => (
                <DatePicker
                    id={id}
                    className={'form-control'}
                    dateFormat='MMMM yyyy'
                    placeholderText='Välj datum'
                    onChange={(date) => field.onChange(endOfMonth ? getEndOfMonth(date) : date)}
                    selected={field.value}
                    showPopperArrow={false}
                    showMonthYearPicker
                    minDate={minDate}
                    maxDate={maxDate}
                    locale={TAFLocale}
                    autoComplete={'off'}
                />
            )}
        />
    );
};
